<template>
  <div class="doc-preview">
    <button
      v-if="collapsible"
      type="button"
      class="btn btn-secondary"
      @click="open = !open"
    >
      {{ open ? 'Ocultar archivo' : 'Ver archivo actual' }}
    </button>

    <!-- Con collapsible cerrado el <embed>/<video> no está en el DOM: el
         navegador no descarga el archivo hasta que el usuario lo pide. -->
    <template v-if="open">
      <div class="doc-preview__meta">
        {{ name }}<span v-if="size"> · {{ sizeLabel }}</span>
      </div>

      <!-- :key fuerza el remount al cambiar de archivo. Sin él, al elegir un
           segundo archivo Vue reescribe el src sobre el mismo elemento y el
           navegador puede seguir mostrando el archivo anterior. -->
      <embed
        v-if="isPdf"
        :key="url"
        class="doc-preview__frame"
        :src="url"
        type="application/pdf"
      />
      <video
        v-else
        :key="url"
        class="doc-preview__frame"
        :src="url"
        controls
        preload="metadata"
      ></video>

      <!-- Siempre visible: <embed> no dispara un onerror confiable, así que
           un navegador que no renderice el PDF deja un recuadro en blanco
           indetectable desde JS. Este link es el único fallback real. -->
      <a class="doc-preview__link" :href="url" target="_blank" rel="noopener">
        Abrir en pestaña nueva
      </a>
    </template>
  </div>
</template>

<script>
export default {
  name: 'DocumentPreview',
  props: {
    url: { type: String, required: true },
    extension: { type: String, required: true },
    name: { type: String, default: '' },
    size: { type: Number, default: 0 },
    collapsible: { type: Boolean, default: false }
  },
  data () {
    return {
      open: !this.collapsible
    }
  },
  computed: {
    isPdf () {
      return String(this.extension).toLowerCase() === 'pdf'
    },
    sizeLabel () {
      return (this.size / 1048576).toFixed(1).replace('.', ',') + ' MB'
    }
  }
}
</script>

<style lang="scss" scoped>
.doc-preview {
  margin: 0.75rem 0;
}

.doc-preview__meta {
  margin-bottom: 0.35rem;
  font-size: 0.85rem;
  color: var(--color-ghost);
  overflow-wrap: anywhere;
}

.doc-preview__frame {
  display: block;
  width: 100%;
  height: 420px;
  background: var(--color-mist);
  border: 1px solid var(--color-line);
}

.doc-preview__link {
  display: inline-block;
  margin-top: 0.35rem;
  font-size: 0.85rem;
}
</style>
